import React from 'react'
import { useSelector } from 'react-redux'
import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer'

const TEETH = {
    mUpper: {
        right: { teeth: [11, 12, 13, 14, 15, 16, 17, 18] },
        left: { teeth: [21, 22, 23, 24, 25, 26, 27, 28] }
    },
    mLower: {
        right: { teeth: [41, 42, 43, 44, 45, 46, 47, 48] },
        left: { teeth: [31, 32, 33, 34, 35, 36, 37, 38] }
    }
}

const KORKHAUS = ['measure', 'kVal', 'diff', '']

const MAIN_MEASURES = ['L', 'Lc', 'Lm', 'archPerimeter']

const EXCESS = ['excess33', 'excess66']

const formatMeasure = value =>
    !isNaN(Number.parseFloat(value)) ? Number.parseFloat(value).toFixed(1) : '-'

export const MeasuresMobile = props => {

    const {
        getmeta,
        getKorkhausValues,
        getNumeric,
        teeth,
        mainMeasures,
        excess,
        korkhaus,
        renderBiteJump,
        biteJump,
        biteJumpValues
    } = props;

    return (
        <section className="specsMobile measures">
            <header>
                <h3>
                    {ihm_viewer__dictionary['SPE_MEASURES'][locale()]}
                    <br/>
                    <span>{ihm_viewer__dictionary['SPE_TOTAL'][locale()]}</span>
                </h3>
            </header>
            <div className="flexContainer">

                <div className="flexItem arcade">
                    <h4>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.ARCH_WIDTH[locale()]}</h4>
                    <div className="containerSpec">
                        <div className="containerTable">
                            {Object.entries(teeth).map( ( [jaw, jawSpecs] ) =>
                                Object.entries(jawSpecs).map(([side, sideSpecs], sideIndex) =>
                                    <table className="full-width" key={'table-' + sideIndex}>
                                        <thead>
                                            <tr>
                                                {sideSpecs.teeth.map( tooth => {
                                                    let info = getmeta('toothID_'+tooth, jaw, 'toothWidths')
                                                    return ( info ) ?
                                                        <th key={'width'+tooth+'name'}>
                                                            <b>{tooth}</b>
                                                        </th> :
                                                        null
                                                    })
                                                }
                                                <th>
                                                    {
                                                        ( side === 'right' ) ?
                                                            ihm_viewer__dictionary.SPE_MEASURES_ITEMS.SUM33[locale()] :
                                                            ihm_viewer__dictionary.SPE_MEASURES_ITEMS.SUM66[locale()]
                                                    }
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                {sideSpecs.teeth.map( tooth => {
                                                    let info = getmeta('toothID_'+tooth, jaw, 'toothWidths')
                                                    return ( info ) ?
                                                        <td key={'width'+tooth+'value'}>
                                                            { getNumeric( info ) }
                                                        </td> :
                                                        null
                                                    })
                                                }
                                                <td>
                                                    {
                                                        ( side === 'right' ) ?
                                                            getNumeric( getmeta( 'sum33', jaw ) ) :
                                                            getNumeric( getmeta( 'sum66', jaw ) )
                                                    }
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                )
                            )}
                        </div>
                    </div>
                </div>

                <div className="flexItem small">
                    <h4>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.MAIN_MEASURES[locale()]}</h4>
                    <div className="containerSpec">
                        <div className="labels">
                            {mainMeasures.map(spec =>
                                <div className="labelItem" key={'mainMeasure'+spec+'title'}>
                                    {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[spec.toUpperCase()][locale()]}
                                </div>
                            )}
                        </div>
                        <div className="containerTable">
                            <table>
                                <thead>
                                    <tr>
                                        <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.UPPER[locale()]}</th>
                                        <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.LOWER[locale()]}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {mainMeasures.map ( spec =>
                                    <tr key={'mainMeasure'+spec}>
                                        {Object.keys(teeth).map( jaw =>
                                            <td key={'mainMeasure'+spec+jaw}>
                                                { getNumeric( getmeta(spec, jaw, 'mainMeasures') ) }
                                            </td>
                                        )}
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div className="flexItem small">
                    <h4>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.BOLTON_ANALYSIS[locale()]}</h4>
                    <div className="containerSpec">
                        <div className="labels">
                            {excess.map(exces =>
                                <div className="labelItem" key={'Excess'+exces+'title'}>
                                    {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[exces.toUpperCase()][locale()]}
                                </div>
                            )}
                        </div>
                        <div className="containerTable">
                            <table>
                                <thead className='tableHead'>
                                    <tr>
                                        <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.VALUE[locale()]}</th>
                                        <th>{ihm_viewer__dictionary.SPE_MEASURES_ITEMS.RATIO[locale()]}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                {excess.map( exces => {
                                    return <tr key={'Excess'+exces+'line'}>
                                        <td key={'Excess'+exces+'value'}>
                                            { getNumeric( getmeta( exces+'Val' ) ) }
                                        </td>
                                        <td key={'Excess'+exces+'ratio'}>
                                            { getNumeric( getmeta( exces+'Ratio' ) ) }
                                        </td>
                                    </tr>
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>


                <div className="flexItem">
                    <h4>
                        {ihm_viewer__dictionary.SPE_MEASURES_ITEMS.KORKHAUS_ANALYSIS[locale()]}
                    </h4>
                    <div className="containerSpec">
                        <div className="containerTable">
                            <table>
                                <thead>
                                    <tr>
                                        <th className="no-border"></th>
                                        {Object.keys(teeth).map((jaw, teethIndex) =>
                                            [
                                                teethIndex > 0 ? <th className="separator" key={jaw + teethIndex + 'sep'}/> : null,
                                                korkhaus.map(value =>
                                                    value !== '' ?
                                                        <th key={'Korkhaus'+jaw+'title'+value}>
                                                            {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[( value === 'measure' )? jaw.charAt(1).toUpperCase()+'_MEASURES': value.toUpperCase()][locale()]}
                                                        </th> :
                                                        null
                                                )
                                            ]
                                        )}
                                    </tr>
                                </thead>
                                <tbody>
                                {Object.values(getKorkhausValues()).map( field =>
                                    <tr key={'Korkhaus'+field+'line'}>
                                        <td className="no-border" key={'Korkhaus'+field+'title'}>
                                            {ihm_viewer__dictionary.SPE_MEASURES_ITEMS[field[0]][locale()]}
                                        </td>
                                        {Object.keys(teeth).map((jaw, teethIndex) =>
                                            [
                                                teethIndex > 0 ? <td className="separator" key={jaw + teethIndex + 'sep'}/> : null,
                                                korkhaus.map(value =>
                                                    value !== '' ?
                                                        <td key={'Korkhaus'+jaw+value+'value'}>
                                                            {getmeta( field[0], jaw, 'korkhaus') ?
                                                                getNumeric( getmeta( field[0], jaw, 'korkhaus')[value] ) :
                                                                '-'
                                                            }
                                                        </td> :
                                                        null
                                                )
                                            ]
                                        )}
                                    </tr>
                                )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {renderBiteJump &&(<div className="flexItem small">
                    <h4>{ihm_viewer__dictionary.SECTION_BITEJUMP[locale()]}</h4>
                    <div className="containerSpec">
                        <div className="labels">
                            {biteJump.map((nom, i) => (
                                <div className="labelItem" key={'biteJumpRow'+i+'title'}>
                                    {nom}
                                </div>
                            ))}

                        </div>
                        <div className="containerTable">
                            <table>
                                <thead className='tableHead'>
                                <tr>
                                    <th>{ihm_viewer__dictionary.SECTION_MEASURES[locale()]}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {biteJump.map((nom, i) => (
                                    <tr key={'bitejumpRow'+i}>
                                        <td>{(i === 1 ? -biteJumpValues[i] : biteJumpValues[i]).toFixed(1)}</td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>)}

            </div>
        </section>
    )
}

export const MobileMeasuresSection = () => {
    const { AnimationReducer, ViewportReducer } = useSelector(s => s)
    const metas = AnimationReducer.metas

    const getmeta = (data = 'all', jaw = null, type = 'global') => {
        if (type === 'global') {
            return jaw === null
                ? metas.measuresAnalysis[data]
                : metas.measuresAnalysis[jaw]?.[data] ?? null
        }
        return data === 'all'
            ? metas.measuresAnalysis[jaw]
                ? Object.entries(metas.measuresAnalysis[jaw][type])
                : null
            : metas.measuresAnalysis[jaw]?.[type]?.[data] ?? null
    }

    const getKorkhausValues = () => getmeta('all', 'mUpper', 'korkhaus') ?? getmeta('all', 'mLower', 'korkhaus')

    const biteJumpVector = ViewportReducer.mandiAdjust
    const biteJumpValues = [biteJumpVector.x, biteJumpVector.y, biteJumpVector.z]
    const renderBiteJump = biteJumpValues.some(v => v !== 0)
    const biteJump = [
        ihm_viewer__dictionary.BITEJUMP_X[locale()],
        ihm_viewer__dictionary.BITEJUMP_Y[locale()],
        ihm_viewer__dictionary.BITEJUMP_Z[locale()]
    ]

    return (
        <MeasuresMobile
            getmeta={getmeta}
            getKorkhausValues={getKorkhausValues}
            getNumeric={formatMeasure}
            teeth={TEETH}
            mainMeasures={MAIN_MEASURES}
            excess={EXCESS}
            korkhaus={KORKHAUS}
            biteJump={biteJump}
            biteJumpValues={biteJumpValues}
            renderBiteJump={renderBiteJump}
        />
    )
}
